module.exports = __webpack_public_path__ + "media/bootstrap-icons/layout-sidebar-reverse-d4aee250.svg";